import React, { useCallback, useRef } from "react";
import { useIntl } from "react-intl";
import styled from "@emotion/styled";
import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import { Toast } from "primereact/toast";
import PrimeReactConstants from "core/app/util/PrimeReactConstants";
import ReportsMessages from "reports/intl/ReportsMessages";

const {
  LEFT,
  MESSAGE_SEVERITY: { INFO },
} = PrimeReactConstants;
const { PLUS } = PrimeIcons;

const StNav = styled.nav`
  position: sticky;
  z-index: 2;
`;

const StContainer = styled.div`
  margin-right: -0.5rem;
`;

const NewReportButton = () => {
  const toastRef = useRef(null);
  const { formatMessage } = useIntl();

  const handleClick = useCallback((evt) => {
    evt.stopPropagation();

    toastRef.current.show({
      detail: "Coming soon!",
      severity: INFO,
      summary: "Info",
    });
    // TODO: Implement new data report creation logic
  }, []);

  return (
    <StNav>
      <StContainer>
        <Toast ref={toastRef} />
        <Button
          icon={PLUS}
          iconPos={LEFT}
          label={formatMessage(ReportsMessages.addDataReport)}
          onClick={handleClick}
        />
      </StContainer>
    </StNav>
  );
};

export default NewReportButton;
